import useCepFormActions from './CepForm.actions.hook';
import useCepFormButtons from './CepFormButtons.hook';
import useCepFormStepper from './CepFormStepper.hook';
import { CepFormSubmitCallbackType } from 'components/CepForm/CepForm.types';
import { useYodaCreateForm } from 'yoda-ui/yodaForm';

const useCepForm = (submitCallback: CepFormSubmitCallbackType, isTemplate: boolean) => {
  const yodaFormMethods = useYodaCreateForm();
  const customerEngagementPlanningActions = useCepFormActions(yodaFormMethods, submitCallback, isTemplate);
  const buttonsConfig = useCepFormButtons(yodaFormMethods, customerEngagementPlanningActions, isTemplate);
  const stepsList = useCepFormStepper(yodaFormMethods.useWatchStep);
  const {
    handleChangeStep,
    stepIndexer,
    syncTargetsLoading,
    openConfirmationModal,
    handleProceed,
    handleCancel,
    openValidationDialog,
    setOpenValidationDialog,
    openFieldsValidationDialog,
    setOpenFieldsValidationDialog,
    invalidTactics,
    cepDateError,
    validationError,
  } = customerEngagementPlanningActions;

  return {
    handleChangeStep,
    yodaFormMethods,
    stepIndexer,
    buttonsConfig,
    stepsList,
    syncTargetsLoading,
    openConfirmationModal,
    handleProceed,
    handleCancel,
    openValidationDialog,
    setOpenValidationDialog,
    openFieldsValidationDialog,
    setOpenFieldsValidationDialog,
    invalidTactics,
    cepDateError,
    validationError,
  };
};

export default useCepForm;
